<script setup lang="ts">
import BadgeItem from '@/common/components/molecules/badge/BadgeItem.vue';
import PopupLayout from '../PopupLayout.vue';
import { setup } from './userSupportPopup.setup';

const { t, moduleInfoList, fileInfoList, isMaxgaugeMode, moduleVersion } = setup();
</script>

<template>
  <popup-layout class="user-support-popup">
    <template #header>
      <div class="user-support-popup__download-container">
        <div class="user-support-popup__download-box">
          <div class="download-section-title">
            {{ t('WORD.GNB.HELP.GUIDE') }}
          </div>
          <v-stack
            :spacing="4"
            class="download-menu-list"
          >
            <a
              v-for="fileInfo in fileInfoList"
              :key="fileInfo.label"
              :href="fileInfo.path"
              :download="fileInfo.name"
              class="download-menu-item"
            >
              <div class="item-text-wrapper">
                <div class="manual-icon"></div>
                <span class="item-text">{{ fileInfo.label }}</span>
              </div>
              <div class="download-link">
                <span class="download-text">{{ t('WORD.DOWNLOAD') }}</span>
                <ev-icon
                  icon="icon-download"
                  size="small"
                  class="download-icon"
                />
              </div>
            </a>
          </v-stack>
        </div>
      </div>
    </template>
    <template
      v-if="!isMaxgaugeMode"
      #list
    >
      <!--      <popup-list-element-->
      <!--        :text="t('WORD.GNB.HELP.MANUAL')"-->
      <!--        icon="icon-send-copy"-->
      <!--        @click="onClickViewManual"-->
      <!--      />-->
      <!--      <stack-separator :style="{ margin: '4px 0 12px' }" />-->
      <v-stack>
        <div class="module-content-wrapper">
          <div
            v-for="moduleInfo in moduleInfoList"
            :key="moduleInfo.title"
            class="module-row"
          >
            <p class="module-title">{{ moduleInfo.title }}</p>
            <badge-item
              size="xsmall"
              html-type="div"
              class="version-badge"
            >
              <span class="version">{{ moduleInfo.version }}</span>
            </badge-item>
          </div>
        </div>
        <div class="module-footer">
          <p class="footer-text">exemONE {{ moduleVersion }}</p>
        </div>
      </v-stack>
    </template>
  </popup-layout>
</template>

<style scoped lang="scss">
.user-support-popup {
  z-index: 9;
  user-select: none;

  &__download-container {
    padding: 6px;
  }

  &__download-box {
    border: 1px solid var(--color-gray-05-03);
    border-radius: 6px;
    background-color: var(--color-gray-06-00);
  }

  .download-section-title {
    padding: 16px 20px 0;
    font-size: 13px;
    font-weight: 500;
    color: var(--color-gray-03-09);
  }

  .download-menu-list {
    padding: 8px 12px;
  }

  .download-menu-item {
    display: flex;
    position: relative;
    gap: 12px;
    align-items: center;
    justify-content: space-between;
    height: 32px;
    padding: 8px;
    cursor: pointer;
    border-radius: 4px;

    &::before {
      position: absolute;
      inset: 0;
      opacity: 0;
      border-radius: 4px;
      background: var(--color-gray-00-12);
      content: '';
    }

    &:hover::before {
      opacity: 0.06;
    }

    .download-link {
      display: none;
      gap: 4px;
      align-items: center;
    }
    &:hover .download-link {
      display: flex;
    }

    .download-icon {
      position: relative;
      z-index: 1;
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      color: var(--color-gray-03-09);
    }
    .download-text {
      padding-top: 2px;
      font-size: 11px;
      font-weight: 500;
      line-height: 120%;
      color: var(--color-gray-03-09);
    }

    .item-text-wrapper {
      display: flex;
      gap: 12px;
      align-items: center;
    }
    .item-text {
      font-size: 14px;
      font-weight: 500;
      color: var(--color-gray-01-11);
    }
    .manual-icon {
      width: 16px;
      height: 16px;
      border-radius: 4px;
      background-color: var(--color-gray-03-09);
      mask: url('@/common/assets/icon-manual.svg') no-repeat center center;
      mask-size: contain;
    }
  }

  .module-content-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px 20px 12px;
  }

  .module-row {
    display: flex;
    gap: 4px;
    align-items: center;

    .module-title {
      flex: 1 0 0;
      margin: 0;
      font-size: 12px;
      font-weight: 500;
      line-height: 1.2;
      color: var(--color-gray-02-10);
    }

    .version-badge {
      flex-shrink: 0;
      padding: 3px 6px;
      border-radius: 999px;
      background-color: var(--color-gray-05-03);

      .version {
        font-size: 10px;
        font-weight: 500;
        color: var(--main-font-color);
      }
    }
  }

  .module-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border-top: 1px solid var(--color-gray-05-03);

    .footer-text {
      font-size: 12px;
      font-weight: 500;
      color: var(--color-gray-03-09);
    }
  }

  :deep(.base-menu-popup__bottom) {
    padding: 0;
  }

  :deep(.base-menu-popup__list) {
    padding: 0;
    border: none;
    background-color: transparent;
  }
}
</style>
